export const OVERLAY_FIND_IN_PAGE_RESULT_TOPIC = 'overlay.find-in-page-result'

export interface OverlayFindInPageRequest {
  text: string
  sessionId: number
  forward: boolean
  findNext: boolean
}

export interface OverlayFindInPageResult {
  sessionId: number
  activeMatchOrdinal: number
  matches: number
  finalUpdate: boolean
}
